import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito tener una idea de negocio ya?',
    answer: 'No. El Método 3x3 empieza justamente ayudándote a generar 3 ideas viables basadas en lo que ya sabes hacer. No necesitas inventar la rueda, solo necesitas identificar qué valor puedes ofrecer hoy.'
  }, {
    question: '¿Sirve si vivo fuera de USA?',
    answer: 'El contenido está diseñado pensando en el mercado de USA (por precios y contexto), pero los principios de validación y ventas funcionan en cualquier país. Si hablas español y quieres vender servicios, te servirá.'
  }, {
    question: '¿Cuánto tiempo necesito dedicarle?',
    answer: 'El plan está diseñado para 5 horas a la semana. Puedes dividirlo en 45 minutos diarios o un bloque grande el fin de semana. La clave es la constancia, no la intensidad.'
  }, {
    question: '¿Es un curso de video?',
    answer: 'No. Es un PDF de acción directa. Sabemos que no tienes tiempo para ver 10 horas de video. Es un manual de trabajo para leer y ejecutar inmediatamente.'
  }, {
    question: '¿Qué pasa si no consigo clientes?',
    answer: "El método está diseñado para que valides rápido. Si después de los 3 micro-tests no hay ventas, el sistema te enseña a 'Matar' la idea y probar la siguiente sin haber perdido meses de trabajo. El objetivo es encontrar lo que funciona rápido."
  }];
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-5" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-6">
      <button className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-7">
        <span className="font-medium text-gray-900 text-lg" data-id="element-8">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-teal-600" data-id="element-9" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-10" />}
      </button>
      {isOpen && <div className="p-5 pt-0 bg-white text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-11">
          <div className="pt-4" data-id="element-12">{answer}</div>
        </div>}
    </div>;
}